import { useLocation, useNavigate } from "react-router-dom";
import { Container } from "../../style/lauout/layout";
import { useAuthStore } from "../../atoms/user.auth.store";
import ModalCenterLayout from "../modal/modal.center.layout";
import { useState } from "react";
import PasswordModify from "./modal/password.modify";

interface ModalProps {
  isOpen: boolean;
  isVisible: boolean;
}

const Header = () => {
  const location = useLocation(); // 현재 경로 가져오기
  const navigate = useNavigate();

  const { role, logout } = useAuthStore();

  const id = JSON.parse(localStorage.getItem("savedLoginInfo") || "{}")?.id;
  const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");

  const [modifyModal, setModifyModal] = useState<ModalProps>({
    isOpen: false,
    isVisible: false,
  });

  // ✅ 로그아웃 핸들러
  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const modifyModalClosed = () => {
    setModifyModal({ isOpen: false, isVisible: false });
  };
  const modifyModalOpened = () => {
    setModifyModal({ isOpen: true, isVisible: true });
  };

  return (
    <Container className={location.pathname !== "/login" ? "bb_1" : ""}>
      <div className="inner">
        {/* <div
          className="logo"
          onClick={() => {
            if (location.pathname === "/login") navigate("/");
          }}
          style={location.pathname === "/login" ? { cursor: "pointer" } : {}}
        >
          <span className="icon-box">
            <img src="/assets/logo.png" alt="" />
          </span>
          <span className="img-box">
            <img src="/assets/logo_txt.png" alt="" />
          </span>

          {location.pathname !== "/login" && (
            // <p className="company-name">주식회사 샌코</p>
            <p className="company-name">{userInfo.companyName}</p>
          )}
        </div> */}

        {location.pathname !== "/login" && (
          <div className="sub">
            <span>
              <strong>안녕하세요.</strong> <b>{id}</b> 님
            </span>
            {role === "user" && (
              <>
                <span className="hr"></span>
                <span style={{ cursor: "pointer" }} onClick={modifyModalOpened}>
                  정보변경
                </span>
                <span className="hr"></span>
              </>
            )}
            <span style={{ cursor: "pointer" }} onClick={handleLogout}>
              로그아웃
            </span>
          </div>
        )}
      </div>

      {modifyModal.isOpen && (
        <ModalCenterLayout
          isVisible={modifyModal.isVisible}
          closedHandler={modifyModalClosed}
        >
          <PasswordModify closedHandler={modifyModalClosed} />
        </ModalCenterLayout>
      )}
    </Container>
  );
};

export default Header;
